package com.ervasstudio.tracoemovimento.pages.blog


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.sections.Footer
import com.ervasstudio.tracoemovimento.model.BlogPost
import com.ervasstudio.tracoemovimento.model.NewsState
import com.ervasstudio.tracoemovimento.repository.BlogRepository
import com.ervasstudio.tracoemovimento.repository.BlogRepository.checkNewsEmailExists
import com.ervasstudio.tracoemovimento.repository.BlogRepository.saveNewsEmail
import com.ervasstudio.tracoemovimento.util.ApiHtmlRenderer
import com.ervasstudio.tracoemovimento.util.Res.Image.evento
import com.huanshankeji.compose.html.material3.MdCircularProgress
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors.Black
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLElement


@OptIn(DelicateApi::class)
@Composable
fun MainSectionBlog(
    isLoading: Boolean,
    selectedPost: BlogPost?,
    listOfPosts: List<BlogPost>,
    onPostClick: (BlogPost) -> Unit,
    localStorageKey: String,
    sessionStorageKey: String,
    isMobile: Boolean,
) {
    val postsFiltrados = listOfPosts.filter { it.id != selectedPost?.id }

    var showNewsPopup by remember { mutableStateOf(false) }
    var newsState by remember { mutableStateOf(NewsState.INVITATION) }
    var newsApiError by remember { mutableStateOf<String?>(null) }

    val coroutineScope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()

    val tamanhoLote = if (breakpoint >= Breakpoint.MD) 6 else 4
    var limiteExibicao by remember(tamanhoLote) { mutableStateOf(tamanhoLote) }

    LaunchedEffect(Unit) {
        val jaCadastrado = window.localStorage.getItem(localStorageKey)
        val negadoAgora = window.sessionStorage.getItem(sessionStorageKey)
        if (jaCadastrado == null && negadoAgora == null) {
            delay(5000)
            newsState = NewsState.INVITATION
            showNewsPopup = true
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier.fillMaxSize()
                .padding(topBottom = if (isMobile) 1.5.cssRem else 4.cssRem),   // era 4.cssRem sempre
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (isLoading) {
                MdCircularProgress(indeterminate = true)
            } else {
                selectedPost?.let { post ->
                    if (isMobile) {
                        BlogPostConteudoMobile(
                            post = post,
                            postsFiltrados = postsFiltrados,
                            limiteExibicao = limiteExibicao,
                            onPostClick = onPostClick,
                            onVerMais = { limiteExibicao += tamanhoLote },
                        )
                    } else {
                        BlogPostConteudoDesktop(
                            post = post,
                            postsFiltrados = postsFiltrados,
                            limiteExibicao = limiteExibicao,
                            onPostClick = onPostClick,
                            onVerMais = { limiteExibicao += tamanhoLote },
                        )
                    }
                }
            } ?: SpanText("Nenhum post encontrado ou erro na autenticação.")

            Row(modifier = Modifier.height(if (isMobile) 4.cssRem else 14.cssRem)) {}   // era 14.cssRem sempre
            Footer(isMobile = isMobile)
        }

        NewsLetterPopup(
            isOpen = showNewsPopup,
            currentState = newsState,
            externalError = newsApiError,
            onClose = {
                showNewsPopup = false
                newsApiError = null
                window.sessionStorage.setItem(sessionStorageKey, "true")
            },
            onAcceptInvitation = { newsState = NewsState.FORM },
            onSendEmail = { emailEnviado ->
                coroutineScope.launch {
                    newsApiError = null
                    newsState = NewsState.LOADING
                    val existe = checkNewsEmailExists(emailEnviado)
                    if (existe) {
                        newsApiError = "Este e-mail já está inscrito nas nossas notícias."
                        newsState = NewsState.FORM
                    } else {
                        val salvoComSucesso = saveNewsEmail(emailEnviado)
                        if (salvoComSucesso) {
                            window.localStorage.setItem(localStorageKey, "true")
                            newsState = NewsState.SUCCESS
                        } else {
                            newsApiError = "Erro no servidor. Tente novamente mais tarde."
                            newsState = NewsState.FORM
                        }
                    }
                }
            }
        )
    }
}

@Composable
private fun BlogPostConteudoDesktop(
    post: BlogPost,
    postsFiltrados: List<BlogPost>,
    limiteExibicao: Int,
    onPostClick: (BlogPost) -> Unit,
    onVerMais: () -> Unit,
) {
    Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.Top) {
        SpanText(
            modifier = Modifier
                .padding(leftRight = 3.cssRem)
                .fontSize(14.cssRem)
                .fontFamily("GothamBlack")
                .id("topo-do-blog")
                .fontWeight(FontWeight.Bold).lineHeight(1).color(White).styleModifier {
                    property("writing-mode", "vertical-lr")
                    property("transform", "rotate(180deg)")
                    property("width", "auto")
                    property("height", "auto")
                },
            text = "BLOG"
        )
        Column(modifier = Modifier.weight(1f)) {
            PostHero(post, isMobile = false)
            PostMeta(post, isMobile = false)
            PostCorpo(post, isMobile = false)
            SimpleGrid(
                numColumns = numColumns(base = 1, sm = 2, md = 3),
                modifier = Modifier.fillMaxWidth().gap(1.cssRem)
            ) {
                postsFiltrados.take(limiteExibicao).forEach { p -> ListaPosts(post = p, onClick = onPostClick) }
            }
            if (limiteExibicao < postsFiltrados.size) VerMaisBotao(onVerMais, isMobile = false)
        }
    }
}

@Composable
private fun BlogPostConteudoMobile(
    post: BlogPost,
    postsFiltrados: List<BlogPost>,
    limiteExibicao: Int,
    onPostClick: (BlogPost) -> Unit,
    onVerMais: () -> Unit,
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        SpanText(
            modifier = Modifier
                .padding(leftRight = 1.cssRem, bottom = 0.5.cssRem)
                .fontSize(2.5.cssRem)                       // era 3.cssRem, e sem rotação
                .fontFamily("GothamBlack")
                .id("topo-do-blog")
                .fontWeight(FontWeight.Bold).lineHeight(1).color(White),
            text = "BLOG"
        )

        PostHero(post, isMobile = true)
        PostMeta(post, isMobile = true)
        PostCorpo(post, isMobile = true)

        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 2, md = 3),
            modifier = Modifier.fillMaxWidth().gap(0.8.cssRem)
        ) {
            postsFiltrados.take(limiteExibicao).forEach { p -> ListaPosts(post = p, onClick = onPostClick) }
        }
        if (limiteExibicao < postsFiltrados.size) VerMaisBotao(onVerMais, isMobile = true)
    }
}

@Composable
private fun PostHero(post: BlogPost, isMobile: Boolean) {
    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.BottomCenter) {
        Image(
            modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Cover),
            src = post.heroshoot.toString(),
        )
        Box(
            modifier = Modifier.fillMaxWidth()
                .padding(
                    top = if (isMobile) 3.cssRem else 6.cssRem,
                    bottom = if (isMobile) 1.cssRem else 2.cssRem,
                    leftRight = if (isMobile) 1.cssRem else 2.cssRem,
                )
                .styleModifier {
                    property(
                        "background",
                        "linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 100%)"
                    )
                },
        ) {
            SpanText(
                modifier = Modifier.color(White).fontFamily("Gotham")
                    .fontSize(if (isMobile) 18.px else 40.px)
                    .fontWeight(FontWeight.Bold).textAlign(TextAlign.Start).styleModifier {
                        property("display", "-webkit-box")
                        property("-webkit-line-clamp", "2")
                        property("overflow", "hidden")
                        property("line-height", "1.2")
                    },
                text = post.titulo
            )
        }
    }
}

@Composable
private fun PostMeta(post: BlogPost, isMobile: Boolean) {
    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(
                top = 1.cssRem,
                right = if (isMobile) 1.cssRem else 2.cssRem,
                left = if (isMobile) 1.cssRem else 0.px
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            modifier = Modifier.width(if (isMobile) 1.1.cssRem else 1.5.cssRem).objectFit(ObjectFit.Cover),
            src = evento,
        )
        SpanText(
            modifier = Modifier.margin(left = 0.5.cssRem).color(White).fontFamily("Gotham")
                .fontSize(if (isMobile) 0.9.cssRem else 1.2.cssRem).textAlign(TextAlign.Start),
            text = post.dataFormatada
        )
    }

    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(
                top = if (isMobile) 1.cssRem else 1.8.cssRem,
                bottom = if (isMobile) 1.cssRem else 2.cssRem,
                right = if (isMobile) 1.cssRem else 2.cssRem,
                left = if (isMobile) 1.cssRem else 0.px,
            )
    ) {
        SpanText(
            modifier = Modifier
                .then(if (isMobile) Modifier.fillMaxWidth() else Modifier.width(80.cssRem))   // era width(80.cssRem)
                .color(Black).fontFamily("Gotham")
                .fontSize(if (isMobile) 1.15.cssRem else 1.6.cssRem)
                .fontWeight(FontWeight.Bold).textAlign(TextAlign.Start),
            text = post.subtitulo!!
        )
    }
}

@Composable
private fun PostCorpo(post: BlogPost, isMobile: Boolean) {
    val larguraConteudo = if (isMobile) Modifier.fillMaxWidth()
        .padding(leftRight = 1.cssRem) else Modifier.width(80.cssRem)   // era width(80.cssRem)

    ApiHtmlRenderer(
        rawHtml = post.corpo!!,
        modifier = larguraConteudo
            .color(Black)
            .fontFamily("museomoderno")
            .fontSize(if (isMobile) 1.cssRem else 1.3.cssRem)   // era 1.3.cssRem
            .textAlign(TextAlign.Start)
    )

    Row(modifier = Modifier.height(if (isMobile) 1.2.cssRem else 2.cssRem)) {}

    Row(
        modifier = larguraConteudo,
        verticalAlignment = Alignment.Top,
    ) {
        GaleriaFotosComClique(
            post.listaDeFotos,
            isMobile = isMobile,
        )
    }

    Row(modifier = Modifier.height(if (isMobile) 2.cssRem else 4.cssRem)) {}

    Column(
        modifier = larguraConteudo,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Start) {
            SpanText(
                modifier = Modifier
                    .padding(left = 0.5.cssRem)
                    .fontSize(if (isMobile) 1.3.cssRem else 2.cssRem)   // era 2.cssRem
                    .fontFamily("GothamBlack")
                    .lineHeight(1.4)
                    .color(White),
                text = "MAIS SOBRE TRAÇO E MOVIMENTO"
            )
        }
    }
}

@Composable
private fun VerMaisBotao(onClick: () -> Unit, isMobile: Boolean) {
    Box(
        modifier = Modifier.margin(topBottom = 2.cssRem)
            .padding(topBottom = 0.8.cssRem, leftRight = 2.cssRem)
            .backgroundColor(Color.black)
            .borderRadius(4.px).cursor(Cursor.Pointer).onClick { onClick() }
    ) {
        SpanText(
            modifier = Modifier.color(Color.white).fontFamily("Gotham")
                .fontSize(if (isMobile) 0.9.cssRem else 1.cssRem)
                .fontWeight(FontWeight.Bold), text = "VER MAIS"
        )
    }
}